import React from "react";
import useStyles from "../../../../styles";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const PdfPreview = React.memo(({ file ,handleRemoveFile,index}) => {
    const classes = useStyles();
    return(
   <div className={classes.relativePostition} style={{width:'76%',backgroundColor: "white"}}>
                       <IconButton
              onClick={() => handleRemoveFile(index)}
              style={{
                position: "absolute",
                top: 10,
                right: 20,
                zIndex: 10, 
                backgroundColor: "transparent", 
                padding: 4,
              }}
            >
              <CloseIcon style={{ color: "#f44336" }} /> 
            </IconButton>
    <iframe
      src={`${URL.createObjectURL(file)}#toolbar=0&navpanes=0&scrollbar=0`}
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
        overflow: "hidden",
        scrollbarWidth: "none",
        backgroundColor: "white",
        msOverflowStyle: 'none',
        background: "white !important"
      }}
      scrolling="no"
      title="PDF Preview"
    />
  </div>
)});

export default PdfPreview;